var React = require('react');

function HasuraioIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(2.715721 0 0 2.715721 291.57608 -455.0722)"},[React.createElement("circle",{"cx":"-169.32","cy":"269.642","fill":"#ffc627","r":"8","key":0}),React.createElement("path",{"d":"m-166.12 272.042-3-5.9c-.3-.5-.9-.7-1.4-.5-.5.3-.7.9-.5 1.4l1.3 2.4-2.2 2.2a1.09 1.09 0 0 0 0 1.5 1.08 1.08 0 0 0 .7.3c.3 0 .5-.1.7-.3l1.8-1.8.7 1.5c.2.4.6.6.9.6.2 0 .3 0 .5-.1.6-.1.8-.7.5-1.3m4-16.3c-.6.4.4 3.8-2 5.9-1.5-1-3.3-1.6-5.2-1.6s-3.7.6-5.2 1.5c-2.4-2-1.4-5.5-2-5.9-1-.6-2.8 3-2.6 5.2.1 1.2.4 3 1.3 4.4-.7 1.3-1 2.7-1 4.3 0 5.3 4.3 9.6 9.6 9.6s9.6-4.3 9.6-9.6c0-1.5-.4-3-1-4.3.9-1.4 1.2-3.2 1.3-4.4 0-2.2-1.8-5.7-2.8-5.1m-7.2 21.3c-4.1 0-7.4-3.3-7.4-7.5 0-4.1 3.3-7.4 7.4-7.4s7.5 3.3 7.5 7.4c0 4.2-3.4 7.5-7.5 7.5","fill":"#232323","key":1})]));
}

HasuraioIcon.defaultProps = {"height":"64","viewBox":"-200 239 64 64","width":"64"};

module.exports = HasuraioIcon;

HasuraioIcon.default = HasuraioIcon;
